"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('ON_LOCALE_CHANGED', function (locale) { return ({
    locale: locale,
}); });
